import styled from 'styled-components';

export const Container = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #e4000b;
  color: white;
  font-size: 10px;
`;
